<template>
    <v-container fluid>
        <div class="display-1 mb-3">Customer Data</div>
        <v-card>
            <v-tabs slider-color="primary">
                <v-tab ripple>{{$t('history')}}</v-tab>
                <v-tab ripple>{{$t('import data')}}</v-tab>
                <v-tabs-items>
                    <v-tab-item key="history">
                        <CustomerDataTable></CustomerDataTable>
                    </v-tab-item>
                    <v-tab-item>
                        <ImportCustomerData></ImportCustomerData>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-card>
    </v-container>
</template>
<script>
import ImportCustomerData from './ImportCustomerData'
import CustomerDataTable from './CustomerDataTable'

export default {
    name      : 'CampaignData',
    components: {
        CustomerDataTable,
        ImportCustomerData
    },
    mounted() {
        this.$appService.hideLoading()
    }
}
</script>
